import { render, staticRenderFns } from "./CrystalViolet_ResultsC.vue?vue&type=template&id=5299e5dc&"
import script from "./CrystalViolet_ResultsC.vue?vue&type=script&lang=js&"
export * from "./CrystalViolet_ResultsC.vue?vue&type=script&lang=js&"
import style0 from "./CrystalViolet_ResultsC.vue?vue&type=style&index=0&id=5299e5dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
